import { SelectOptionType } from "types/select/SelectOptionType";

export enum TipoSituacaoProcessoJudicial {
  NOVO = "NOVO",
  CANCELADO = "CANCELADO",
  PROCURACAO_ENVIADA_PARA_SINDICO = "PROCURACAO_ENVIADA_PARA_SINDICO",
  AR_ENVIADO = "AR_ENVIADO",
  AR_POSITIVO = "AR_POSITIVO",
  AJUIZADO = "AJUIZADO",
  ACAO_DE_COBRANCA = "ACAO_DE_COBRANCA",
  ACAO_DE_EXECUCAO = "ACAO_DE_EXECUCAO",
  PROCESSO_FINALIZADO = "PROCESSO_FINALIZADO",
}

export const getSitucaoProcessoJudicial = (situacaoProcesso: TipoSituacaoProcessoJudicial) => {
  switch (situacaoProcesso) {
    case TipoSituacaoProcessoJudicial.NOVO:
      return "Novo";
    case TipoSituacaoProcessoJudicial.CANCELADO:
      return "Cancelado";
    case TipoSituacaoProcessoJudicial.PROCURACAO_ENVIADA_PARA_SINDICO:
      return "Procuração enviada para o síndico";
    case TipoSituacaoProcessoJudicial.AR_ENVIADO:
      return "A.R enviado";
    case TipoSituacaoProcessoJudicial.AR_POSITIVO:
      return "A.R positivo";
    case TipoSituacaoProcessoJudicial.AJUIZADO:
      return "Ajuizado";
    case TipoSituacaoProcessoJudicial.ACAO_DE_COBRANCA:
      return "Ação de cobrança";
    case TipoSituacaoProcessoJudicial.ACAO_DE_EXECUCAO:
      return "Ação de execução";
    case TipoSituacaoProcessoJudicial.PROCESSO_FINALIZADO:
      return "Processo finalizado";
  }
};

export const getipoSitucoesProcessoJudicalValue = (option: SelectOptionType<TipoSituacaoProcessoJudicial>) => {
  return option !== undefined && option !== null ? option.value : null;
};

export const tipoSitucoesProcessoJudical: SelectOptionType<TipoSituacaoProcessoJudicial>[] = [
  {
    value: TipoSituacaoProcessoJudicial.ACAO_DE_COBRANCA,
    label: "Ação de cobrança",
  },
  {
    value: TipoSituacaoProcessoJudicial.ACAO_DE_EXECUCAO,
    label: "Ação de execução",
  },
  {
    value: TipoSituacaoProcessoJudicial.AJUIZADO,
    label: "Ajuizado",
  },
  {
    value: TipoSituacaoProcessoJudicial.AR_ENVIADO,
    label: "A.R enviado",
  },
  {
    value: TipoSituacaoProcessoJudicial.AR_POSITIVO,
    label: "A.R positivo",
  },
  {
    value: TipoSituacaoProcessoJudicial.CANCELADO,
    label: "Cancelado",
  },
  {
    value: TipoSituacaoProcessoJudicial.NOVO,
    label: "Novo",
  },
  {
    value: TipoSituacaoProcessoJudicial.PROCURACAO_ENVIADA_PARA_SINDICO,
    label: "Procuração enviada para o sindico",
  },

  {
    value: TipoSituacaoProcessoJudicial.PROCESSO_FINALIZADO,
    label: "Processo finalizado",
  },
];
